// ShowReportsMenuField.jsx
import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useRecordContext } from 'react-admin';

const applyTemplate = (tpl, record) =>
  tpl.replace(/\{([\w.]+)\}/g, (_, path) => {
    const parts = path.split('.');
    let val = record;
    for (const p of parts) val = val?.[p];
    return encodeURIComponent(val ?? '');
  });

export default function ShowReportsMenuField({ extraProps, source_name }) {
  const record = useRecordContext();
  const [anchorEl, setAnchorEl] = React.useState(null);

  if (!record) return null;

  const {
    buttonLabel = 'Reports',
    statusField = 'status_id',
    hideOnStatuses = [1], // hide for status 1 by default
    rules = [],
    defaultItems = [],
  } = extraProps || {};

  const statusVal = Number(record?.[statusField] ?? 0);

  // Hide button entirely for specified statuses
  if (hideOnStatuses.includes(statusVal)) return null;


  // Collect ALL matching rules instead of just first
const matchedRules = rules.filter((r) => {
  const inMatch =
    Array.isArray(r.in) && r.in.includes(statusVal);

  const hasRange =
    typeof r.min === 'number' || typeof r.max === 'number';

  const rangeMatch =
    hasRange &&
    (typeof r.min !== 'number' || statusVal >= r.min) &&
    (typeof r.max !== 'number' || statusVal <= r.max);

  return inMatch || rangeMatch;
});

// Merge all matched items
const items = matchedRules
  .flatMap((r) => r.items || [])
  .map((i) => ({
    label: i.label,
    url: applyTemplate(i.urlTemplate, record),
  }));

// Fallback to default items if none matched
const finalItems = items.length > 0
  ? items
  : defaultItems.map((i) => ({
      label: i.label,
      url: applyTemplate(i.urlTemplate, record),
    }));

if (finalItems.length === 0) return null;



  const open = Boolean(anchorEl);
  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleOpenReport = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
      >
        {buttonLabel}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items.map((it) => (
          <MenuItem key={it.label} onClick={() => handleOpenReport(it.url)}>
            {it.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
